import { render, staticRenderFns } from "./dlgEditor.vue?vue&type=template&id=4f8ba7ff&"
import script from "./dlgEditor.vue?vue&type=script&lang=js&"
export * from "./dlgEditor.vue?vue&type=script&lang=js&"
import style0 from "./dlgEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8ba7ff')) {
      api.createRecord('4f8ba7ff', component.options)
    } else {
      api.reload('4f8ba7ff', component.options)
    }
    module.hot.accept("./dlgEditor.vue?vue&type=template&id=4f8ba7ff&", function () {
      api.rerender('4f8ba7ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/commentaire/dlgEditor.vue"
export default component.exports